import * as React from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import { IconButton, TextField } from "@mui/material";

import { CloseIcon } from "@/modules/Core/Icons/Close";
import { CloseSVG } from "./CloseSVG";

export default function ContinueModal({
  open,
  handleContinue,
  handleUpload,
  handleClose,
}) {
  return (
    <Modal
      open={open}
      // onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box
        sx={(theme) => ({
          position: "absolute" as "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: "640px",
          bgcolor: "background.paper",
          boxShadow: 24,
          padding: "24px",
          borderRadius: "32px",
          [theme.breakpoints.down("sm")]: {
            width: "343px",
            padding: "16px",
            borderRadius: "16px",
          },
        })}
      >
        <IconButton
          aria-label="delete"
          onClick={handleClose}
          sx={(theme) => ({
            position: "absolute",
            top: "24px",
            right: "24px",
            padding: "0",
            [theme.breakpoints.down("sm")]: {
              top: "16px",
              right: "16px",
            },
          })}
        >
          <CloseSVG />
        </IconButton>
        <Typography
          sx={(theme) => ({
            color: "#1C1C1E",
            fontSize: "24px",
            fontWeight: "600",
            lineHeight: "31px",
            marginBottom: "24px",
            [theme.breakpoints.down("sm")]: {
              marginRight: "36px",
            },
          })}
        >
          Вы не подтвердили доход
        </Typography>
        <Typography
          sx={(theme) => ({
            color: "#676971",
            fontSize: "16px",
            fontWeight: "400",
            lineHeight: "22px",
            marginBottom: "85px",
          })}
        >
          Вы уверены, что хотите продолжить без подтверждения дохода? В этом
          случае вероятность одобрения составляет 50%
        </Typography>

        <Box
          sx={(theme) => ({
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            gap: "12px",
            [theme.breakpoints.down("sm")]: {
              flexDirection: "column",
            },
          })}
        >
          <Button
            sx={(theme) => ({
              padding: "13px 24px",
              backgroundColor: "#F3F3F7",
              color: "#1C1C1E",
              fontSize: "16px",
              fontWeight: "500",
              lineHeight: "24px",

              borderRadius: "10px",
              ":hover": {
                background: "#F3F3F7",
                color: "#1C1C1E",
              },
              [theme.breakpoints.down("sm")]: {
                width: "100%",
              },
            })}
            onClick={handleUpload}
          >
            Прикрепить документы
          </Button>
          <Button
            sx={(theme) => ({
              padding: "13px 24px",
              backgroundColor: "#27AE60",
              color: "#FFF",
              fontSize: "16px",
              fontWeight: "500",
              lineHeight: "24px",

              borderRadius: "10px",
              ":hover": {
                background: "#27AE60",
                color: "#FFF",
              },
              [theme.breakpoints.down("sm")]: {
                //   marginTop: '',
                width: "100%",
              },
            })}
            onClick={handleContinue}
          >
            Продолжить без подтверждения
          </Button>
        </Box>
      </Box>
    </Modal>
  );
}
